module.exports = __webpack_public_path__ + "img/tcd.d5427bed.png";